<!-- Loading [START] -->
<div id="loading">
  <div class="loading-center">
    <img src="./assets/images/loader.gif" alt="loader" />
  </div>
</div>
<!-- Loading [END] -->
